import { useState } from "react";
import { toCurrency } from "utils/helpers";
import Table from "utils/Table/Table";
import ProviderFilters from "../../common/ProviderFilters";
import {
	providerFiltersDefaultValues,
	providerPricingTableData,
	providerPricingTableHeadings,
} from "../../helpers/data";

const ProviderPricingTable = () => {
	const [formValues, setFormValues] = useState({
		...providerFiltersDefaultValues,
	});

	const handleChange = ({ target: { name, value } }) =>
		handleSelect(name, value);

	const handleSelect = (name, value) => {
		console.log({ name, value });
		setFormValues((prev) => ({
			...prev,
			[name]: value,
		}));
	};
	const handleSubmit = () =>
		setFormValues({ ...providerFiltersDefaultValues });

	const getWalletData = () =>
		providerPricingTableData?.map((wallet) => ({
			paymentType: wallet?.paymentType,
			chargingType: wallet?.chargingType,
			val: toCurrency(wallet?.value),
			cap: wallet?.cap,
			action: wallet?.action,
		}));

	const handleRowClick = (_, rowValues) => {
		// history.push(`/providers/${rowValues.transactionID}/overview`);
	};
	return (
		<>
			<div className="position-relative">
				<ProviderFilters
					formValues={formValues}
					handleChange={handleChange}
					handleSubmit={handleSubmit}
					handleSelect={handleSelect}
				/>
				<Table
					data={getWalletData()}
					headings={providerPricingTableHeadings}
					rowClick={handleRowClick}
				/>
			</div>
		</>
	);
};

export default ProviderPricingTable;
